import { render, staticRenderFns } from "./LogPersonFilter.vue?vue&type=template&id=1dc60cb4&scoped=true&"
import script from "./LogPersonFilter.vue?vue&type=script&lang=js&"
export * from "./LogPersonFilter.vue?vue&type=script&lang=js&"
import style0 from "./LogPersonFilter.vue?vue&type=style&index=0&id=1dc60cb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc60cb4",
  null
  
)

export default component.exports